export const breakpointLg = 992; // if updated, also update in variables.scss
export const breakpointMd = 780; // if updated, also update in variables.scss

export const isMobile = () => window.innerWidth < breakpointLg;

export const isDesktop = () => window.innerWidth >= breakpointLg;

export const isTablet = () => window.innerWidth >= breakpointMd;

export const focusElement = (id) => {
    const elementDom = document.getElementById(id);

    if(elementDom) {
        elementDom.focus();
    }
}

export const isSafari = () =>
    typeof window !== 'undefined'
        ? window.navigator.userAgent.indexOf('Safari') > -1 &&
        window.navigator.userAgent.indexOf('Chrome') <= -1
        : null;

export const isDecember = () => {
    const today = new Date();
    return today.getMonth() === 11;
}

export const isJanuary = () => {
    const today = new Date();
    return today.getMonth() === 0;
}

export const getNewYearDayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const newYearsDay = new Date(year + 1, 0, 1);

    return newYearsDay;
}
